module.exports = __webpack_public_path__ + "static/bg-8c40f61ec1b63f573dbf6c7a132d40ea.png";